import styled from 'styled-components';

export const StyledMessage = styled.div`
  display: flex;
  position: relative;
  min-height: 1em;
  margin: 24px 0;
  padding: 24px;
  transition: opacity 0.1s ease, color 0.1s ease, background 0.1s ease,
    box-shadow 0.1s ease;
  border-radius: 4px;
  border: 1px solid ${({ theme }) => theme.colors.accentGray04};
`;

export const StyledTypeContainer = styled(StyledMessage)`
  width: 100%;
  z-index: ${({ theme }) => theme.zIndex.alerts};

  &.default {
    background: ${({ theme }) => theme.colors.accentGray01};
    color: ${({ theme }) => theme.colors.headingBlacker};
  }

  &.error {
    border-color: ${({ theme }) => theme.colors.errorRed01};
    color: ${({ theme }) => theme.colors.errorRed01};
    background: ${({ theme }) => theme.colors.errorRed02};
  }

  &.info {
    border-color: ${({ theme }) => theme.colors.deepBlue};
    background: ${({ theme }) => theme.colors.white};
    color: ${({ theme }) => theme.colors.headingBlacker};
    .icon svg g {
      fill: ${({ theme }) => theme.colors.deepBlue};
    }
  }

  &.success {
    border-color: ${({ theme }) => theme.colors.acceptedGreen};
    background: ${({ theme }) => theme.colors.white};
    color: ${({ theme }) => theme.colors.acceptedGreen};
    .icon path {
      fill: ${({ theme }) => theme.colors.acceptedGreen};
    }
  }

  &.no_content {
    z-index: ${({ theme }) => theme.zIndex.zero};
    background: ${({ theme }) => theme.colors.white};
    color: ${({ theme }) => theme.colors.accentGray05};
    font-style: italic;
    margin: 0 auto;
    .alert-header {
      color: ${({ theme }) => theme.colors.black};
      font-size: 24px;
      font-style: normal;
      margin-bottom: 14px;
    }
    .alert-content {
      margin: 0 auto;
    }
  }
`;

export const StyledHeader = styled.div`
  display: block;
  opacity: 0.85;
`;

export const StyledBody = styled.div`
  opacity: 0.85;
  display: block;
  text-align: left;
  white-space: pre-wrap;
`;

export const StyledContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-top: -0.25em;
`;

export const StyledCloseButton = styled.div`
  position: absolute;
  top: 8px;
  right: 8px;
  display: block;
`;

const iconSize = 40;

export const StyledIcon = styled.div`
  height: ${iconSize}px;
  width: ${iconSize}px;
  min-width: ${iconSize}px;
  display: block;
  margin-right: 24px;
  margin-top: 4px;
`;
